import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
import { mdiUpload } from '@mdi/js'
import { useImage } from '@/shared/composables/image'
import { Organization } from '@/modules/Organizations/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateOrganizationInfo',
  props: {
    org: null
  },
  emits: ['update'],
  setup(__props: any, { emit }) {

const props = __props as {
  org: Organization
};

const { saveImage, getOrgImage } = useImage()





const orgImage = ref('')
const orgImageFile = ref<FileList | null>(null)

const changeImage = (e: Event) => {
  const target = e.target as HTMLInputElement
  const filesImg = target.files

  if (!filesImg || filesImg.length === 0) return

  const reader = new FileReader()
  reader.onload = (event) => {
    orgImage.value = event.target?.result as string
    orgImageFile.value = filesImg
  }
  reader.readAsDataURL(filesImg[0])
}

const nextStage = async () => {
  if (orgImageFile.value) {
    props.org.image = await saveImage(orgImageFile.value[0])
  }

  emit('update')
}

onMounted(() => {
  orgImage.value = getOrgImage(props.org.image, 1000)
})

return { __sfc: true,saveImage, getOrgImage, props, emit, orgImage, orgImageFile, changeImage, nextStage, mdiUpload }
}

})